// extracted by mini-css-extract-plugin
module.exports = {"CreateAccount":"CreateAccount_CreateAccount__2wLMy"};